import gql from 'graphql-tag'

import { PAGE_INFO } from './catalogQuery'
import { ELEMENT_SEO_FIELDS } from './seoQuery'
export const LOOKBOOK_ITEM_PREVIEW_FILEDS = gql`
  fragment lookbookPreviewFields on Element {
    name
    id
    code
    sort
    detailPicture {
      url
      id
    }
    sections {
      code
      id
    }
  }
`

export const LOOKBOOK_ITEMS = gql`
  query lookbook_items(
    $where: ElementWhereInput
    $first: Int
    $last: Int
    $order: ElementOrderByInput
    $after: String
  ) {
    elements(
      where: $where
      first: $first
      last: $last
      order: $order
      after: $after
    ) {
      nodes {
        ...lookbookPreviewFields
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${LOOKBOOK_ITEM_PREVIEW_FILEDS}
  ${PAGE_INFO}
`

export const LOOKBOOK_ITEM = gql`
  query lookbook_item($where: ElementWhereInput!) {
    item: element(where: $where) {
      active
      name
      code
      id
      ...elementSeoFields
      detailPicture {
        url
        id
      }

      propertyValues {
        id
        property {
          id
          code
          name
        }
        value
      }

      propertyValuesRelation {
        id
        property {
          name
          code
          id
        }
        targetElement {
          id
          code
          name

          sections {
            id
            code
            name
          }
        }
        targetElements {
          id
          code
          name
          priceBase
          priceBaseWithDiscount
          bx_id
          active
          activeFrom
          activeTo
          productType

          parentSection {
            id
            active
            code
            name

            parentSection {
              id
              code
              name
              active
            }
          }

          propertyValuesRelation {
            id
            property {
              id
              code
              name
            }

            targetHlElement {
              id
              name
            }
          }

          parentProduct {
            id
            name
            code
            sections {
              id
              code
              name

              parentSection {
                id
                code
                name
              }
            }
          }
        }
      }
    }
  }

  ${ELEMENT_SEO_FIELDS}
`
